module.exports = __webpack_public_path__ + "img/DI_DT.157ed8b3.png";